
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_34135_151424)"}},[_c('path',{attrs:{"d":"M3.5 2A1.5 1.5 0 002 3.5v9A1.5 1.5 0 003.5 14h9a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0012.5 2h-9zm9 13c1.379 0 2.5-1.121 2.5-2.5V6h1.5A1.5 1.5 0 0118 7.5v9a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 016 16.5V15h6.5z","fill":"#999"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_34135_151424"}},[_c('path',{attrs:{"fill":"#fff","transform":"matrix(-1 0 0 1 18 2)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    